module.exports = __webpack_public_path__ + "static/img/ai-followup.52f602f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ai-followup.svg
// module id = Bcu2
// module chunks = 10